var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSphere20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319474"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 215",
    cx: 10,
    cy: 10,
    r: 8.97534,
    fill: "#00C2FF",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 216",
    cx: 12.5625,
    cy: 6.0625,
    r: 2.125,
    fill: "#BDF0FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSphere20);
export default __webpack_public_path__ + "static/media/sphere_20.87576761b4605eea6300b0ab5869f458.svg";
export { ForwardRef as ReactComponent };